import { SelectField } from '@dispatch/web/ui';
import { Grid } from '@mui/material';
import {
  Control,
  FieldValues,
  UseFieldArrayAppend,
  UseFormWatch,
} from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import { AttributeForm, ResourceForm } from '@dispatch/shared/types';
import { emptyBoolForm } from '@dispatch/shared';

export type AttributeAddProps = {
  append: UseFieldArrayAppend<FieldValues, 'attributes'>;
  control: Control<FieldValues>;
  watch: UseFormWatch<ResourceForm>;
};

export function AttributeAddBulk({ append, control, watch, company }: any) {
  const handleAddAttribute = (value: unknown) => {
    const rawValue = value as { title: string; value: string };
    const selectedAttribute = getSelectedAttributeData(rawValue.value);

    append(selectedAttribute);
  };

  const getSelectedAttributeData = (integrationGUID: string): AttributeForm => {
    const selectedAttribute = company?.attributeDefinition?.find(
      (attribute: any) => attribute.integrationGUID === integrationGUID
    );

    return {
      integrationGUID: uuidv4(),
      attributeDefinitionIntegrationGUID:
        selectedAttribute?.integrationGUID || '',
      displayName: selectedAttribute?.displayName || '',
      selectedAttributeValuesVarchars: [],
      selectedAttributeValuesBools: emptyBoolForm(),
    };
  };

  const getFilteredOptions = () => {
    const formAttributes = watch('attributes');
    const companyAttributes = company?.attributeDefinition;

    if (!formAttributes || !companyAttributes) {
      return (
        companyAttributes?.map((value: any) => {
          return {
            title: value.displayName,
            value: value.integrationGUID,
          };
        }) || []
      );
    }

    const filteredCompanyAttributes = companyAttributes?.filter(
      (companyAttr: any) => {
        return !formAttributes.find(
          (formAttr: any) =>
            formAttr.attributeDefinitionIntegrationGUID ===
            companyAttr.integrationGUID
        );
      }
    );

    return filteredCompanyAttributes.map((value: any) => {
      return {
        title: value.displayName,
        value: value.integrationGUID,
      };
    });
  };

  return (
    <div
      style={{
        padding: '24px',
      }}
    >
      <Grid container rowSpacing={4} spacing={2}>
        <Grid data-testid="add-attribute" size={6}>
          <SelectField
            id="addSelectedAttributeGUID"
            name="addSelectedAttributeGUID"
            label="Add New Attribute"
            control={control}
            onValueChange={handleAddAttribute}
            options={getFilteredOptions()}
          />
        </Grid>
      </Grid>
    </div>
  );
}
